var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container cont_kisa mt-5"},_vm._l((_vm.sayilar),function(i){return _c('div',{key:i},[_vm._v(" "+_vm._s(i)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }